var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column boxedContent",style:(_vm.widthBox)},[_c('span',[_c('i',{staticClass:"fas fa-circle",style:(_vm.colorPoin)})]),_c('span',{staticClass:"pa-2 text-center black--text"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }